import { useLocation } from "react-router-dom"
import DlspTaskDetails from "./DlspTaskDetails"

export default function DlspTaskDetailsWithRefresh() {

    // See: https://github.com/remix-run/react-router/issues/7416
    const location = useLocation()
    console.log('DlspTaskDetailsWithRefresh location', location)
    return (
        <DlspTaskDetails key={location.key} />
    )
}